// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2R6s5","select":"Header_select__ZBlwW","clinic":"Header_clinic__2BVXh"};